/*global kakao*/ 
// ↳ kakao 객체가 선언되지 않았다는 오류 해결
import React, { useEffect, useState } from 'react';
import jsonData from "./map_info.json";
import $ from 'jquery';
import '../../css/KakaoMap.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from "axios";

const KakaoMap = (props) => {
  const [modalTitle, setModalTitle] = useState(0);//확진자 번호 state 변수 선언 1 2 3 4 5 ...
  const [viaPath, setViaPath] = useState({'key':''});//확진자 이동경로 변수 선언
  //첫 렌더링에 return함수에서 viaPath[0].key 값이 없으면 오류 발생 > {'key':''}로 초기화
  const [responseInfectList, setResponseInfectList] = useState([{}]);
  //MySql에서 읽어온 확진자 데이터를 할당하는 변수

  const [modal, setModal] = useState(false);//이동경로 팝업의 노출/비노출을 결정하는 변수
  const toggle = (num) => {//이동경로 팝업의 toggle 이벤트에 연결된 함수
    setModal(!modal)//toggle함수 실행시, 이전 팝업 노출 상태의 반대로 변경
    if(num != 'Cancel'){
      setModalTitle(num)//toggle함수 파라미터가 Cancel이 아니면, 팝업 노출할 num를 할당
                        //클릭된 마커의 데이터만 노출하기 위해, modalTitle에 num 할당
    }else{
      $(".modal").remove()//toggle함수 파라미터가 Cancel이면, 모든 팝업을 삭제
                          //어차피 2개 이상 팝업이 노출되는 상황은 없음.
    }
  };

  useEffect(() => {
    callInfectListApi();//db에서 데이터를 읽어오는 node api호출 함수
    let result = document.querySelector('#mainNav');//header영역을 id값으로 선택
    $( "#appendp" ).css( "margin-top", result.offsetHeight );//넓게보기, n번재 확진자로 이동 버튼 노출을 위해
                                                             //header영역만큼 상단을 띄워서 노출
  }, []);//컴포넌트 첫 렌더링시 실행

  useEffect(() => {
    if(responseInfectList[0].num != undefined){
      mapscript();//첫 렌더링에 map을 그려주는 함수 호출
    }
  }, [responseInfectList]);

 // KakaoMap.js 내의 callInfectListApi 함수 수정 제안
const callInfectListApi = async () => {
    try {
        const response = await axios.post('/api/infection?type=list', {});
        if (response.data && response.data.result) {
            setResponseInfectList(response.data.result);
        }
    } catch (error) {
        // 에러 발생 시 콘솔에 상세 내용을 찍어 도커/네트워크 문제인지 확인합니다.
        console.error("API 호출 에러 상세:", error.response || error.message);
        alert('데이터를 불러오지 못했습니다. 콘솔 로그를 확인하세요.');
    }
}

  const mapscript = () => {//카카오지도를 id가 map인 태그안에 그려주는 함수
    var mapContainer = document.getElementById('map'),
    mapOption = { 
        center: new kakao.maps.LatLng(37.505496, 127.005116), //초기 지도 중앙값 설정
                                                              // 서울의 위도와 경도
        level: 9 //숫자가 작을수록 확대된영역을 볼 수 있다.(좁은 지역)
    }
    var map = new kakao.maps.Map(mapContainer, mapOption)//두 옵션 정보를 담아서 map변수에 할당

    var clusterer = new kakao.maps.MarkerClusterer({//클러스터 옵션을 변수에 할당
      map: map,//마커들을 클러스터로 관리하고 표시할 지도 객체 
      averageCenter: true,//클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정 
      minLevel: 5 // 클러스터 할 최소 지도 레벨 
                  // 1, 2, 3, 4 레벨에서는 마커가 모두노출, 5부터 인접한 마커가 클러스터링됨
    });
    let viapath = [];//jsonData.positions의 이동경로(via_path)를, #으로 분리해 삽일할 배열
    
    var markers = $(responseInfectList).map(function(i, position) {// MySql 데이터 > 반복문을 통해 리턴된 marker들을 markers변수에 할당
    // var markers = $(jsonData.positions).map(function(i, position) {// json 데이터 > 반복문을 통해 리턴된 marker들을 markers변수에 할당
    // 상단에 import한 /map_info.json파일에서 데이터를 가져와 map함수로 반복
      var imageSrc = require("../../img/hop0"+(i+1)+".png").default
      // 상대경로로 확진자 이미지를 가져와 변수에 할당
      if(position.finish == '완치'){
        imageSrc = require("../../img/clearp0"+(i+1)+".png").default
        // 상대경로로 완치자 이미지를 가져와 변수에 할당
      }
      
      var pa_num = position.num
      //n번째 확진자도 이동 버튼생성을 위해, 현재 번호를 할당
      var pa_numstr = ""
      if(pa_num < 10){//번호가 10미만일 경우 앞에 0을 붙인다
        pa_numstr = "0"+pa_num
      }else{
        pa_numstr = ""+pa_num
      }
       
      if($(".btna").length == i){//n번째 확진자로 이동 버튼이 여러번 출력되는 경우를 방지 
        $("#appendp").append('<button class=\"btn btna btn-outline-info\" lat=\"'+position.lat+'\" lng=\"'+position.lng+'\">'+pa_numstr+'번</button>')
      }

      if(position.via_path != undefined){//이동경로 값이 있을때
        const viapathArr = position.via_path.split("#");//이동경로를 #을 기준으로 나눠서 순서대로 배열에 할당
        //position[0].via_path가 a#b#c, position[1].via_path가 d#e#f
        viapath.push({'key':viapathArr})//viapath[0] = [a,b,c], viapath[1] = [d,e,f]
      }
      
      var imageSize = new kakao.maps.Size(60, 70)//마커이미지의 가로, 세로 크기
      var imageOption = {offset: new kakao.maps.Point(27, 69)}//이미지 좌표로 기본값인 27보다 크면 서쪽으로, 69보다 크면 북쪽으로 이동

      var markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)//이미지경로, 사이즈, 상대 좌표로 변수 할당
      var marker = new kakao.maps.Marker({//마커 정보를 마커 marker변수에 할당
          map: map,//마커를 표시할 지도
          position : new kakao.maps.LatLng(position.lat, position.lng),//마커를 표시할 위치(좌표)
          image: markerImage//마커에 노출될 이미지
      });

      //커스텀 오버레이 영역 html코드, css소스는 /css/KakaoMap.css에 작성해 import함
      var content = '<div class="overlaybox">' +
          '    <div class="boxtitle boxtitle_'+i+'">'+position.num+'번째 확진자</div>' +
          '    <div class="boxtitle2 boxtitle2_'+i+'" style="margin-left: 150px;"><font color="white"">닫기 버튼 [X]</font></div>'+
          '    <div class="first first_'+position.num+'">' +
          '        <div class="triangle text">'+position.num+'</div>' +
          '        <div class="movietitle text">'+position.comment+'</div>' +
          '    </div>' +
          '    <ul style = "overflow:scroll">' +
          '        <li class="up">' +
          '            <span class="number">격리:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.date+'</span>' +
          '            <span class="number">완치:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.finish_date+'</span>' +
          '        </li>' +
          '        <li class="up">' +
          '            <span class="number">성별:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.gender+'</span>' +
          '            <span class="number">생년:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.birth+'</span>' +
          
          '        </li>' +
          '        <li class="up">' +
          '            <span class="number">국적:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.nation+'</span>' +
          '            <span class="number">접속자수:</span>' +
          '            <span class="title" style="font-weight:bold;color:white">'+position.contact+'</span>' +
          '        </li>' +
          '    </ul>' +
          '</div>';
      
      var customOverlay = new kakao.maps.CustomOverlay({//마커 수 만큼 customOverlay 생성
        position: new kakao.maps.LatLng(position.lat, position.lng),//마커 좌표 할당
        content: content,//html소스할당
        xAnchor: 0.25,//마커 기준 x 상대 좌표 설정
        yAnchor: 1.02//마커 기준 y 상대 좌표 설정
      });

      var clickHandler1 = function(event) {//마커 수 만큼 clickHandler1 함수 실행
          customOverlay.setMap(map);//생성한 customOverlay를 지도에 표시

          //이동경로 팝업을 띄우기 위한 클릭이벤트  
          $(".boxtitle_"+i).click(function(){// 마커별로 각각의 클릭이벤트 적용 / 5개 마커 > 5개의 click이벤트 생성
            toggle(i)//각각의 마커별 toggle함수 파라미터 변경 / toggle(1) toggle(2) ...toggle(5)
          });

          //이동경로 팝업을 닫기 위한 클릭이벤트
          $(".boxtitle2_"+i).click(function(){// 마커별로 각각의 클릭이벤트 적용 / 5개 마커 > 5개의 click이벤트 생성
            customOverlay.setMap(null);//각각의 마커별 customOverlay 삭제 적용
          });

          $(".first_"+position.num).css({"background":"url("+position.hospi_img+")",//커스텀오버레이에 배경 이미지 경로 할당
          "background-size" :"247px 247px"});//커스텀오버레이에 배경 이미지 사이즈 할당
      }; 

      kakao.maps.event.addListener(marker, 'click', clickHandler1)//마커별로 각각 click 이벤트 적용
      return marker;//반복문이 한 번 돌때마다 marker정보를 리턴
    })//$(jsonData.positions).map 함수 end

    $(".btna").click(function(e){//n번째 확진자로 바로가기 버튼 클릭
      var lat = $(this).attr('lat')// class가 btna인 버튼의 lat(위도)값을 가져온다
      var lng = $(this).attr('lng')// class가 btna인 버튼의 lng(경도)값을 가져온다
      map.setLevel(4);//클러스터링이 되지않는 레벨로 지도 확대
      var moveLatLon = new kakao.maps.LatLng(lat, lng);
      map.panTo(moveLatLon);//클릭한 번호의 마커 좌표로 이동  
    });

    $("#wideView").click(function(){//넓게 보기 버튼 누르면
      map.setLevel(9);//지도를 축소
    })

    if(viapath != undefined){
      setViaPath(viapath)//반복문(map함수)안에서 만들어진 확진자별 이동경로 
                         //배열(viapath)를 state변수인 viapath에 저장
    }
    // state변수 viapath 배열
    // [
    //   {'key':['(1월 22일) 내용1', '(1월 23일) 내용2', '(1월 24일) 내용3']}, //1번째 확진자 이동경로
    //   {'key':['(1월 23일) 내용1', '(1월 24일) 내용2', '(1월 25일) 내용3']}, //2번째 확진자 이동경로
    //   {'key':['(1월 28일) 내용1', '(1월 29일) 내용2', '(1월 30일) 내용3']} //3번째 확진자 이동경로
    // ]
    
    clusterer.addMarkers(markers);//반복문을 통해 수집된 마커들에 클러스터링을 적용
  }

  return (
    <>
    <div id="appendp">
      <Button id="wideView" className="btn btn-outline-info">넓게보기</Button>{' '}
    </div>
    <div id="map" style={{"width":"100%","height":"700px"}}>
      <div>
        <Modal isOpen={modal} toggle={e => toggle('Cancel', e)} >{/* 배경클릭 */}
          <ModalHeader toggle={e => toggle('Cancel', e)}>{modalTitle+1}번째 확진자 정보</ModalHeader>{/* X 클릭 */}
          <ModalBody>
            {   //조건부 렌더링을 위해, 3항 연산자 사용 

                //조건부 렌더링은 조건에 따라 화면에 표시할 내용을 다르게 처리하는 것
                // 조건 ? true일 경우 소스 : false일 경우 소스
                // viaPath[modalTitle]가 undefined이면 viaPath[modalTitle].key에서 오류 발생
                viaPath[modalTitle] == undefined ? '' :
                (viaPath[modalTitle].key).map(x => 
                  {
                  console.log("modalTitle : "+modalTitle+" x : "+x)
                    return (//map 함수가 html코드를 반복적으로 반환
                      <div>
                        {x}
                      </div>
                    )
                  }
                )
            } 
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={e => toggle('Cancel', e)}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
    </>
  );
};

export default KakaoMap;